import { twMerge } from '@/lib/classname/twMerge'
import type { ResponsiveProp } from '@/lib/device/useBreakpoint'
import type { ButtonSize, ButtonVariant } from './ButtonStyles'
import { buttonResponsiveClasses } from './ButtonStyles'

export type LinkButtonUnderlineMode = 'invert' | 'hover' | 'none'

export type BuildButtonClassNameOptions = {
  className?: string
  variant: ResponsiveProp<ButtonVariant>
  size?: ResponsiveProp<ButtonSize>
  isRound?: ResponsiveProp<boolean>
  takesParentWidth?: boolean
  linkUnderlineMode?: LinkButtonUnderlineMode
}

export function buildButtonClassName({
  className,
  variant,
  size = 'md',
  isRound = false,
  takesParentWidth,
  linkUnderlineMode,
}: BuildButtonClassNameOptions): string {
  return twMerge(
    className,
    'btn',
    takesParentWidth && 'btn-full-width',
    ...buttonResponsiveClasses(variant, 'btn'),
    ...buttonResponsiveClasses(size, 'btn'),
    ...buttonResponsiveClasses(isRound, 'btn-round'),
    linkUnderlineMode === 'hover' && 'btn-link--underline-hover',
    linkUnderlineMode === 'none' && 'btn-link--underline-none',
  )
}
